export enum EFactsheetTabs {
  OVERVIEW = 'overview',
  PERFORMANCE = 'performance'
}
